export interface ISipAssuredHeading {
  title?: string;
  amount?: number;
  currency?: string;
  frequency_term?: string;
  frequency?: number;
  month_interval?: number;
  hide_Warning_icon?: boolean;
  warning_text?: string;
  tenure?: number;
}

export const SIP_ASSURED_HEADING_DEFAULT_CONFIG: ISipAssuredHeading = {
  title: 'Monthly Giving',
  currency: 'INR',
  hide_Warning_icon: false
};
